var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShieldLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3.924v7.614c0 2.407.729 4.757 2.092 6.741s3.294 3.508 5.54 4.372l1.041.4a3 3 0 0 0 2.154 0l1.041-.4c2.246-.864 4.178-2.389 5.54-4.372s2.092-4.334 2.092-6.741V3.924a1.49 1.49 0 0 0-.233-.809c-.154-.242-.374-.434-.635-.553A21.7 21.7 0 0 0 12 .751a21.7 21.7 0 0 0-8.882 1.811c-.261.119-.481.311-.635.553s-.235.523-.233.809h0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.75h9v7.5h-9v-7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25a3 3 0 0 0-3 3v1.5h6v-1.5a3 3 0 0 0-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.156c.074 0 .147.022.208.063s.11.1.138.168.036.144.021.217-.05.14-.103.192-.119.088-.192.103-.148.007-.217-.021-.127-.076-.168-.138-.063-.134-.063-.208c0-.099.04-.195.11-.265s.166-.11.265-.11",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldLock);
export default __webpack_public_path__ + "static/media/icon_shield_lock.2cda0d8ba1e58dcd4752c1b4663f19d0.svg";
export { ForwardRef as ReactComponent };